import { render, staticRenderFns } from "./Duihuan.vue?vue&type=template&id=3213b482&scoped=true&"
import script from "./Duihuan.vue?vue&type=script&lang=js&"
export * from "./Duihuan.vue?vue&type=script&lang=js&"
import style0 from "./Duihuan.vue?vue&type=style&index=0&id=3213b482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3213b482",
  null
  
)

export default component.exports